/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

import permissions from '../../../common/constants/permissions';

import './batch.tpl.html';
import './batchDetail.tpl.html';

angular
  .module('admin.batch', ['ngAnimate', 'services.permissions'])
  .controller(
    'AdminBatchCtrl',
    function (
      $rootScope,
      $scope,
      $filter,
      $state,
      $uibModal,
      $q,
      httpQueue,
      progressFactory,
      batchUtils,
      dashboardPrefs,
      permissionService,
      batchesInfo,
      batchPrimaryObjectCounts,
      orgInfo,
      ALERT_EVENTS,
      BATCH_LIMITS,
      VIEW_STATES
    ) {
      var STATUS = batchUtils.STATUS,
        NOBATCH = 'NONE';
      // Check batchesInfo and redirect view to first time view if there are no batches.
      if (batchesInfo.count === 0) {
        $state.go(VIEW_STATES.ADMIN_START);
      }
      $rootScope.showLoadingMask = true;

      $scope.batches = [];
      $scope.showBatchOne = true;
      $scope.enableBatchAnimation = false;
      $scope.batchesLoaded = false;

      // For the dashboard prefs in the batchDetail directive
      $scope.dashboardPrefs = dashboardPrefs;

      // For the primary object counts in the batchDetail directive
      $scope.batchPrimaryObjectCounts = batchPrimaryObjectCounts;

      // For the custom backup time in the batchDetail directive
      $scope.orgInfo = orgInfo;

      /**
       * Function that will pad the loaded batches to ensure there are 12 and
       * set the current batch to that one found at index 0.
       *
       * @param {object[]} batchesInfo The array of batches returned from the server.
       */
      function setBatches(batchesInfo) {
        // pad the array with empty objects if there are not enough batches to fill the bar.
        while (batchesInfo.rows.length < 12) {
          batchesInfo.rows.push({
            status: NOBATCH
          });
        }

        $scope.batches = batchesInfo.rows;
        if ($scope.batches.length > 0) {
          $scope.setBatch(0, false);
        }
      }

      /**
       * Function that loads the 12 most recent batches.
       *
       * @returns {Promise} A promise that will set the batches.
       */
      function loadRecentBatchData() {
        // retrieve both the backup dots and counts so the entire dashboard renders properly
        var loadPromises = [
          batchUtils.getBackupBatchDots(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD, true),
          batchUtils.getBatchPrimaryObjectCounts(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD)
        ];

        return $q.all(loadPromises).then(
          function (batchesAndCounts) {
            // set this scope variable before we set the batches, as setBatches() will eventually call
            // setBatch(0), which pulls primary object counts out of the scope variable
            $scope.batchPrimaryObjectCounts = batchesAndCounts[1];

            // now setup all of the backup batch dots (including padding any empty items), and update the
            // dashboard with the details of the most recent batch
            setBatches(batchesAndCounts[0]);
          },
          function () {
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_BATCH_DATA_FAILED'));
          }
        );
      }

      /**
       * Utility function used to clear the selected value from all batches.
       */
      function clearSelected() {
        angular.forEach($scope.batches, function (batch) {
          batch.selected = false;
        });
      }

      /**
       * Create a class list for the passed batch based on it's properties.
       *
       * @param {Object} batch A batch object.
       * @param {boolean} last True if this is the last batch in the list.
       *
       * @returns {string} A space delimited string of classes that are valid for the boink.
       */
      $scope.getBoinkClass = function (batch, last) {
        batch = batch || {};
        var cls = STATUS[batch.status].boinkCls || '';

        if (batch.selected) {
          cls = cls + ' sbsf-boink-selected';
        }

        if (last) {
          cls = cls + ' sbsf-boink-last';
        }

        return cls;
      };

      /**
       * Handler for all link that direct the app to the history log.
       */
      $scope.gotoHistory = function () {
        $state.go(VIEW_STATES.LOG_HOME);
      };

      /**
       * Handler for delete items link to direct app to deleted items.
       */
      $scope.goToDeletedItems = function () {
        $state.go(VIEW_STATES.BULK_RESTORE_SELECT_DEST);
      };

      /**
       * Builds the tooltip content for a batch history boink based on the batch found at the passed
       * index in the batches scope object.
       * @param {Number} index The index of the batch in the batches array.
       *
       * @returns {string|boolean} An html fragment to be provided to the tooltip directive.  If the index is
       *   invalid returns an empty string indicating that no tooltip should be shown.
       */
      $scope.getTooltipText = function (index) {
        if ($scope.batches && $scope.batches[index] && $scope.batches[index].status !== NOBATCH) {
          var batch = $scope.batches[index],
            batchMoment = moment(batch.date),
            dateStr = batchMoment.format('MMM D[,] YYYY'),
            timeType = $filter('i18n')('TIME_TYPE', [batchMoment.format('h:mm a'), $filter('i18n')('BACKUP')]),
            colorCls = STATUS[batch.status].textCls,
            pct = batchUtils.getBatchPercent(batch),
            pctComplete = $filter('i18n')('PERCENT_PROTECTED', pct || '0'),
            errorText = $filter('pluralize')(batch.errors, 'SINGLE_ERROR', 'NUM_ERRORS'),
            warningText = $filter('pluralize')(batch.warnings, 'SINGLE_WARNING', 'NUM_WARNINGS');

          return $filter('i18n')('BATCH_TTIP_TEMPLATE', [
            dateStr,
            timeType,
            colorCls,
            pctComplete,
            errorText,
            warningText
          ]);
        } else {
          // return an empty string so no ttip is shown.
          return '';
        }
      };

      /**
       * Utility function for setting the current selected batch in the batches array.  Updates all
       * scope properties bound to the batch template based on the selected batch.
       *
       * @param {Number} batchIndex - The index of the batch in the batches array.
       * @param {boolean} autoJump - Whether to jump to the details view if batch is already selected.
       */
      $scope.setBatch = function (batchIndex, autoJump) {
        var batch = $scope.batches[batchIndex],
          primaryObjectsInfo = $scope.batchPrimaryObjectCounts[batch.batchId];

        // If current selected batch is the batch that was clicked then jump to batch
        if ($scope.currentBatch === batch && autoJump) {
          $scope.goToBatch();
          return;
        }

        // Only set the batch if the status is valid.
        if (batch.status !== NOBATCH) {
          // If the index is not 0 enable the animations
          if (batchIndex !== 0) {
            $scope.enableBatchAnimation = true;
          }

          // When the showBatchOne value is toggled it will result in the animation
          // in the UI.  To give the ui as much chance as possible to be ready for that
          // set the data bound vars first.  This is why the falsey is used here.
          if (!$scope.showBatchOne) {
            $scope.batchOne = batch;
          } else {
            $scope.batchTwo = batch;
          }
          $scope.showBatchOne = !$scope.showBatchOne;

          // clear the previously selected batch.
          clearSelected();
          batch.selected = true;

          // Set a property if this is the batch at position 0
          if (batchIndex === 0) {
            batch.first = true;
          }

          // inject the type counts into the batch
          batch.typeCounts = primaryObjectsInfo;

          // now set the current batch
          $scope.currentBatch = batch;
        }
      };

      /**
       * Submit a backup to be queued.
       */
      $scope.submitBackup = function () {
        return httpQueue.submitBackup().then(
          function () {
            progressFactory.backupInProgress = true;
          },
          function () {
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('SUBMIT_BACKUP_FAILED'));
            progressFactory.backupInProgress = false;
          }
        );
      };

      /**
       * Redirect the view to the batch detail view.
       */
      $scope.goToBatch = function () {
        return permissionService.hasPermission(permissions.ACTIVITY_HISTORY).then((hasPermission) => {
          if (hasPermission) {
            batchUtils.currentBatch = $scope.currentBatch;
            $state.go(VIEW_STATES.BATCH_HOME, { batchId: $scope.currentBatch.batchId });
          }
        });
      };

      /**
       * Function to launch the backup time modal.
       */
      $scope.openAvgBackupTimeModal = function () {
        $uibModal.open({
          templateUrl: 'shared/modal/avgBackupTimeModal.tpl.html',
          controller: 'AvgBackupTimeModalCtrl',
          windowClass: 'sbsf-avg-backup-time-modal-window',
          backdrop: 'static'
        });
      };

      // Watches to toggle the tooltip state on the backup and export buttons when there are changes in backup/export state.
      $scope.$watch('backupInProgress ', function (newVal, oldVal) {
        $scope.backupBtnTooltip = $scope.backupInProgress
          ? $filter('i18n')('ACTION_PROGRESS_TTIP', $filter('i18n')('BACKUP'))
          : '';
        if (newVal !== oldVal && !$scope.backupInProgress) {
          loadRecentBatchData();
        }
      });
      $scope.$watch('exportInProgress', function () {
        $scope.exportBtnTooltip = $scope.exportInProgress
          ? $filter('i18n')('ACTION_PROGRESS_TTIP', $filter('i18n')('EXPORT'))
          : '';
      });

      // load the batches from the initial resolved value.
      loadRecentBatchData().finally(function () {
        $scope.batchesLoaded = true;
        $rootScope.showLoadingMask = false;
      });
    }
  )
  /**
   *  Controller for a batch detail view directive.
   */
  .controller(
    'AdminBatchDetailCtrl',
    function ($scope, $state, $filter, batchUtils, permissionService, TYPES, VIEW_STATES) {
      var STATUS = batchUtils.STATUS,
        backupStartTime = $scope.$parent.orgInfo ? $scope.$parent.orgInfo.backupStartTime : null,
        batchDate,
        errorText,
        warningText,
        wasWereText,
        backupStartTimeStr,
        localBackupStartTime,
        todayTomorrowStr;

      // Need to get this from parent scope (the view) since this is the controller for the directive
      // and we cant resolve the dashboardPrefs dependency directly in this controller.
      $scope.dashboardPrefs = $scope.$parent.dashboardPrefs;
      $scope.TYPES = TYPES;
      $scope.animationCls = 'sbsf-slide-in';

      if (_.isNumber(backupStartTime) && backupStartTime >= 0 && backupStartTime < 24) {
        // create a moment in UTC since that is how we store the backup time and convert to local time.
        localBackupStartTime = moment.utc().hour(backupStartTime).local();
        todayTomorrowStr = moment().isBefore(localBackupStartTime)
          ? $filter('i18n')('TODAY')
          : $filter('i18n')('TOMORROW');
        backupStartTimeStr = $filter('i18n')('NEXT_AUTOMATED_BACKUP', [
          localBackupStartTime.startOf('hour').format('h:mm A'),
          todayTomorrowStr
        ]);
      }

      $scope.backupStartTimeTxt = backupStartTimeStr;

      /**
       * Returns the shortened version of the number if it is >=1000 for the type and object.
       *
       * @param {string} type - The object type.
       * @param {string} recordType - The record type.
       *
       * @return {string} The number or shortened version of the number
       */
      $scope.getTypeCount = function (type, recordType) {
        var objectType = $scope.batch.typeCounts[type],
          record = objectType ? objectType[recordType] : 0,
          num = record || 0;
        return $filter('shortNum')(num);
      };

      if ($scope.batch) {
        batchDate = moment($scope.batch.date);
        $scope.batch.selected = true;
        errorText = $filter('pluralize')($scope.batch.errors, 'SINGLE_ERROR', 'NUM_ERRORS');
        warningText = $filter('pluralize')($scope.batch.warnings, 'SINGLE_WARNING', 'NUM_WARNINGS');
        wasWereText = $scope.batch.errors === 1 ? $filter('i18n')('WAS_NO_COLON') : $filter('i18n')('WERE');

        $scope.batchDate = $filter('i18n')('BATCH_DATE', [
          batchDate.format('ddd,  MMM D[,] YYYY'),
          batchDate.format('h:mm A')
        ]);
        $scope.bigBoinkCls = STATUS[$scope.batch.status] ? STATUS[$scope.batch.status].bigBoinkCls : '';
        $scope.protectedPctCls = STATUS[$scope.batch.status].textCls;
        $scope.batchMsg =
          ($scope.batch.first ? $filter('i18n')('BATCH_LATEST_PREFIX') : $filter('i18n')('BATCH_OTHER_PREFIX')) +
          $filter('i18n')(STATUS[$scope.batch.status].batchMsgKey);
        $scope.protectedPct = $filter('i18n')('PERCENT_PROTECTED', batchUtils.getBatchPercent($scope.batch));
        $scope.batchWarn = $filter('i18n')('BATCH_MSG_TEMPLATE', [wasWereText, errorText, warningText]);
      }

      /**
       * Redirect the view to the batch detail view.
       */
      $scope.goToBatch = function (objectType) {
        return permissionService.hasPermission(permissions.ACTIVITY_HISTORY).then((hasPermission) => {
          if (hasPermission) {
            batchUtils.currentBatch = $scope.batch;
            // Tell the details view we're coming from a specific object type
            batchUtils.initialObjectType = objectType;
            $state.go(VIEW_STATES.BATCH_HOME, { batchId: $scope.batch.batchId });
          }
        });
      };
    }
  )
  /**
   * The directive for the batch detail view.
   */
  .directive('batchDetail', function () {
    return {
      templateUrl: 'admin/batch/batchDetail.tpl.html',
      scope: {
        batch: '=batch'
      },
      controller: 'AdminBatchDetailCtrl'
    };
  });
